import { secureOrigin } from '@maxpreps/network/src/origins';
import { safeEncodeUri } from '../primitiveHelpers/urlHelpers';

const getWebFormsAdminUrl = (
  page: string,
  accessId1: string,
  accessId2: string,
  roletype = ''
): string =>
  `${secureOrigin}/utility/member/admin_gateway.aspx?accessid1=${accessId1}&accessid2=${accessId2}&destination=${encodeURIComponent(
    page
  )}&roletype=${roletype}`;

export const getWebFormsTeamAdminUrl = (
  page: string,
  schoolId: string,
  allSeasonId: string,
  sportSeasonId: string,
  roleType?: string
): string => {
  let destination = page;

  // if we have a sport season, then we need to route the user through the change season redirect page.
  // from there, we'll take the user to their final destination
  if (sportSeasonId) {
    destination = `/admin/coach/change_season.aspx?ssid=${sportSeasonId}&destination=${safeEncodeUri(
      page
    )}`;
  }

  return getWebFormsAdminUrl(destination, schoolId, allSeasonId, roleType);
};

/*export const getWebFormsSchoolAdminUrl = (
  page: string,
  schoolId: string,
  roleType?: string
) => getWebFormsAdminUrl(page, schoolId, undefined, roleType);

export const getWebFormsAssociationAdminUrl = (
  page: string,
  associationId: string,
  roleType?: string
) => getWebFormsAdminUrl(page, associationId, undefined, roleType);*/
